export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',
	tableHeader: 'text-[10px] font-medium uppercase tracking-wider text-subtle',
};
